export const HOME = '/';
export const ADMIN_SETTINGS = '/admin-settings';
export const ACCOUNT_CENTER = '/account-centre';
export const GATHER_INFORMATION = '/auth/gather-information';

export const ADMIN_PERMISSION_ID = 'SADM';
export const ALL_USER_PERMISSION = [ADMIN_PERMISSION_ID];

export const PRIVATE_ROUTE_USER_TYPE_CONFIG = {
  [HOME]: ALL_USER_PERMISSION,
  [ADMIN_SETTINGS]: ALL_USER_PERMISSION,
  [ACCOUNT_CENTER]: ALL_USER_PERMISSION,
  [GATHER_INFORMATION]: ALL_USER_PERMISSION,
  '/settings': ALL_USER_PERMISSION,
  '/settings/account-settings': ALL_USER_PERMISSION,
  '/settings/account-settings/password-management': ALL_USER_PERMISSION,
  '/settings/notifications-settings': ALL_USER_PERMISSION,
  '/settings/faq': ALL_USER_PERMISSION,
  '/settings/feedback': ALL_USER_PERMISSION,
  '/settings/app-preference': ALL_USER_PERMISSION,
  '/settings/privacy-policy': ALL_USER_PERMISSION,
  '/settings/terms-&-conditions': ALL_USER_PERMISSION,
  '/edit-profile': ALL_USER_PERMISSION,
  '/gather-requirements': ALL_USER_PERMISSION,
};
